import { BrowserRouter } from 'react-router';

import { ErrorBoundary } from '@/shared/ui';

import { AppProviders } from './providers/AppProviders';
import { UpdateNotice } from './providers/UpdateNotice';
import { AppRouter } from './router/AppRouter';

/**
 * De buitenste grens. Valt de schil zelf om - de sessie, de querycache, de
 * router - dan is dit het enige wat er nog tussen de gebruiker en een witte
 * pagina staat. Een kapot *scherm* komt hier niet: dat vangt de grens in
 * `AppShell` op, zodat de rail blijft staan.
 */
export function App() {
    return (
        <ErrorBoundary scope="app">
            <BrowserRouter>
                <AppProviders>
                    <AppRouter />
                </AppProviders>
                <UpdateNotice />
            </BrowserRouter>
        </ErrorBoundary>
    );
}
